import { Accordion, Alert } from "@mantine/core";
import { Link } from "react-router";
import { AlertPresets } from "../../../mantine/mantinePresets";
import type { Meter } from "../../../utils/backend-types";
import "./DataWarningAlert.scss";

interface DataWarningAlertProps {
  objectMeters: Array<Pick<Meter, "id" | "name">>;
}

function DataWarningAlert({ objectMeters }: DataWarningAlertProps) {
  return (
    <Alert
      className="DataWarningAlert"
      color={AlertPresets.warning.color}
      icon={AlertPresets.warning.icon}
    >
      <div>
        Überprüfen Sie die Verbrauchsanteile für folgende Zähler:
        {objectMeters.length === 1 && <span> {objectMeters[0].name}</span>}
      </div>
      {objectMeters.length > 1 && (
        <Accordion>
          <Accordion.Item value="meter-list">
            <Accordion.Control>Zähler-Liste</Accordion.Control>
            <Accordion.Panel>
              <ul className="object-list">
                {objectMeters?.map((meter) => (
                  <li key={meter.id}>
                    <Link to={`verbrauchsanteile/${meter.id}`}>
                      {meter.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </Accordion.Panel>
          </Accordion.Item>
        </Accordion>
      )}
    </Alert>
  );
}

export { DataWarningAlert, DataWarningAlertProps };
